import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React from 'react'

import FilterLanguage from '@/legacy-src/components/filters/LanguageFilter'

import { useIsOfflineAllowedByCompany } from '@/src/domains/client-booking/hooks/useIsOfflineAllowedByCompany'
import { TherapistSessionFilterMenuUI } from '@/src/domains/therapist-filters/components/TherapistSessionFilterMenu'

import ExtendedFilter from './ExtendedFilter'
import useShowSpecializations from './hooks/useShowSpecializations'
import FilterInsurance from './InsuranceFilter'
import SearchName from './SearchName'
import Sort from './Sort'
import FilterSpecialization from './SpecializationFilter'
import TimeFilters from './timeFilters/TimeFilters'
import FilterTraining from './TrainingFilter'

const Item: React.FC<{ className?: string; children: React.ReactNode }> = ({ children, className }) => (
  <div className={`m-2 ${className}`}>{children}</div>
)

const Filters: React.FC = () => {
  const isOfflineEnabled = useFeatureIsOn('offline-therapy-enable-user-booking')
  const isOfflineAllowedByCompany = useIsOfflineAllowedByCompany()
  const isOfflineFilterAvailable = isOfflineEnabled && isOfflineAllowedByCompany

  const displayLanguages = useFeatureIsOn('display-therapist-languages')

  const showSpecializations = useShowSpecializations()

  const renderDesktop = () => (
    <div className="relative -m-2 mb-8 flex flex-wrap justify-center">
      {showSpecializations ? (
        <Item>
          <FilterSpecialization />
        </Item>
      ) : null}
      {isOfflineFilterAvailable ? (
        <Item>
          <TherapistSessionFilterMenuUI />
        </Item>
      ) : null}
      <Item>
        <TimeFilters />
      </Item>
      <Item>
        <ExtendedFilter menuClassName="absolute left-auto right-auto" closeOnOutsideClick>
          <div className="-m-1 p-0">
            <Item>
              <FilterTraining />
            </Item>
            <Item>
              <FilterInsurance />
            </Item>
            {displayLanguages && (
              <Item>
                <FilterLanguage />
              </Item>
            )}
          </div>
        </ExtendedFilter>
      </Item>
      <div className="flex items-center">
        <Item>
          <Sort />
        </Item>
        <Item>
          <SearchName />
        </Item>
      </div>
    </div>
  )

  const renderMobile = () => (
    <div className="-m-2 mb-8 flex justify-center">
      <div className="flex w-full max-w-[500px] flex-wrap justify-center">
        <div className="w-full">
          <Item>
            <ExtendedFilter>
              {showSpecializations ? (
                <Item>
                  <FilterSpecialization />
                </Item>
              ) : null}
              {isOfflineFilterAvailable ? (
                <Item>
                  <TherapistSessionFilterMenuUI />
                </Item>
              ) : null}
              <Item>
                <TimeFilters />
              </Item>
              <Item>
                <FilterTraining />
              </Item>
              <Item>
                <FilterInsurance />
              </Item>
              {displayLanguages && (
                <Item>
                  <FilterLanguage />
                </Item>
              )}
            </ExtendedFilter>
          </Item>
        </div>
        <div className="flex w-full">
          <Item className="flex-grow">
            <Sort />
          </Item>
          <Item>
            <SearchName />
          </Item>
        </div>
      </div>
    </div>
  )

  return (
    <div className="w-full">
      <div className="tablet:hidden">{renderMobile()}</div>
      <div className="hidden tablet:block">{renderDesktop()}</div>
    </div>
  )
}

export default Filters
